import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import Home from "../pages/web/Home";

export const publicRoutes = [
    { path: '/', name: 'Home', Component: Home },
    { path: '/login', name: 'Login', Component: Login },
    { path: '/register', name: 'Register', Component: Register },
];